import { AppBar, Box, Toolbar, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Link from "@mui/material/Link";

const NavBar: React.FC = () => {
  return (
    <AppBar
      position="static"
      sx={{ backgroundColor: "#1e1e1e", boxShadow: "none" }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Typography variant="h6" sx={{ color: "#FFD700" }}>
          <Box display="inline" fontWeight="bold">
            <Link
              component={RouterLink}
              to={"/dashboard"}
              color="inherit"
              variant="h6"
              underline="none"
              fontSize="30px"
              fontWeight="bold"
            >
              Sea Monitoring
            </Link>
          </Box>
        </Typography>
        <Box>
          <Link
            component={RouterLink}
            to={"/manage-dashboard"}
            color="inherit"
            variant="h6"
            underline="none"
            fontSize="16px"
          >
            Manage Dashboard
          </Link>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
